import React from 'react'
import SelectCard from '../Card/SelectCard'
import dineInImg from "../../../Assets/SelfOrder/order-more.png"
import takeAwayImg from "../../../Assets/SelfOrder/online-order.png"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { setSelfOrderScreen } from './selfOrderEssentialsSlice'
import { formatCurrencyValue, selfOrderClear } from '../../SelfGeneralFunctions'
import { onGoingOrdersForSelf } from '../../API/selfOrderAPIS'
import { cancelOngoingOrderApiCall } from '../../../component/Modules/Sales/Billing/API/viewOrderSection'
import { getFloorDetailsForBilling } from '../../../component/Modules/Sales/Billing/API/billingFloorSection'

const OrderConfirmScreen = () => {

  const dispatch = useDispatch()

  const selfUser = localStorage.getItem("selfUser")
  const decimalPosition=localStorage.getItem("decimalPosition")
  const { selfSingleOrderInfo } = useSelector((state) => state.selfOrderMainSlice)
  const { receiptData } = useSelector((state) => state.viewOrdersBillingSlice);
  const {currencyDetails}=useSelector((state)=>state.mainDashBoardSlice)
  const { branchPk, data } = useSelector((state) => state.loginResponseSlice.value)
  const { branchConfigurationList } = useSelector((state) => state.newBillingSlice)

  const storedOrderId = localStorage.getItem("selfOrderId")
  const resolvedOrderId =
    selfSingleOrderInfo?._id ||
    (storedOrderId === "null" || storedOrderId === null ? null : storedOrderId)

  const cardClick = (click) => {
    if (click === "update") {
      dispatch(setSelfOrderScreen("orderProductLists"))
    } else {
      // Navigate to payment options screen instead of directly completing
      dispatch(setSelfOrderScreen("paymentScreen"))
    }
  }

  // Cancel an existing ongoing order (mirrors the web POS / ongoing-orders dialog flow)
  const cancelOrderClick = () => {
    if (!resolvedOrderId) return

    let payload = { orderId: resolvedOrderId, branchId: branchPk, password: "" }

    const postFn = () => {
      onGoingOrdersForSelf({ type: 1, waiterId: data?._id, branchId: branchPk })
      const floorId = localStorage.getItem("defaultFloorId")
      if (branchPk && floorId) getFloorDetailsForBilling({ id: floorId, branchId: branchPk })
      selfOrderClear()
    }

    const requiresPassword = branchConfigurationList?.cancelOrdAuth

    Swal.fire({
      text: requiresPassword ? "Enter your password to cancel this order" : "Confirm to cancel this order",
      icon: 'warning',
      input: requiresPassword ? 'password' : null,
      inputPlaceholder: "Enter password",
      confirmButtonColor: '#f80000',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Back',
      customClass: {
        cancelButton: 'sweet-alert-cancel-button',
        confirmButton: 'sweet-alert-submit-button',
      },
      showCancelButton: true,
      reverseButtons: true,
      didOpen: () => {
        const input = Swal.getInput()
        if (input) input.focus()
      },
      preConfirm: (password) => {
        if (requiresPassword && !password) {
          Swal.showValidationMessage('Password is required!')
          return false
        }
        return password || ""
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (requiresPassword) payload.password = result.value
        cancelOngoingOrderApiCall(payload, postFn)
      }
    })
  }
  return (
    <div className='order-confirm-screen'>
      <h3>{selfSingleOrderInfo?.name}</h3>
      <div className="justify-center" style={{ gap: "15px", flexWrap: "wrap" }}>
        <SelectCard image={dineInImg} label="ADD-MORE +" onClick={() => cardClick("update")} labelStyle={{ color: "#f5585c" }} imgStyle={{ minHeight: "auto" }} />
        <SelectCard image={takeAwayImg} label="COMPLETE" onClick={() => cardClick("complete")} labelStyle={{ color: "#388e3c" }} imgStyle={{ minHeight: "auto" }} />
      </div>

      {selfUser === "STAFF" && resolvedOrderId &&
        <div className="justify-center" style={{ margin: "10px 0" }}>
          <button className="btn-red-outlined" style={{ minWidth: "200px" }} onClick={cancelOrderClick}>
            CANCEL ORDER
          </button>
        </div>
      }

      <div class="price-breakdown-container">
        <h2>Order Summary</h2>

        {receiptData?.orderInfo?.length > 0 &&
          <div className="order-summary-items">
            {receiptData?.orderInfo?.map((item, i) => (
              <div className="price-item order-summary-item" key={i}>
                <span>{(item?.desccription || item?.description || item?.productName || "")} × {item?.qty ?? item?.quantity ?? 0}</span>
                <span>{formatCurrencyValue(item?.lineTotal || 0, currencyDetails, decimalPosition)}</span>
              </div>
            ))}
          </div>
        }

        <div class="price-details">
          <div class="price-item">
            <span>PAX:</span>
            <span>{receiptData?.orderInfo?.length}</span>
          </div>
          <div class="price-item">
            <span>Taxable amount:</span>
            <span>{formatCurrencyValue(receiptData?.taxableAmt || 0, currencyDetails, decimalPosition)}</span>
          </div>
          {
            receiptData?.taxDetails &&
            receiptData?.taxDetails?.map((item,i)=>(
              <div class="price-item" key={i}>
                <span>{item?.taxName || ""}</span>
                <span>{formatCurrencyValue(item?.amount || 0, currencyDetails, decimalPosition)}</span>
              </div>
            ))
          }
        {
        receiptData?.pkgCharge>0 &&
        <div class="price-item">
            <span>Packaging Charge:</span>
            <span>{formatCurrencyValue(receiptData?.pkgCharge || 0, currencyDetails, decimalPosition)}</span>
          </div>}
          <div class="price-item total">
            <span>Total:</span>
            <span>{formatCurrencyValue(receiptData?.amtTotal || 0, currencyDetails, decimalPosition)}</span>
          </div>
        </div>
      </div>


    </div>
  )
}

export default OrderConfirmScreen